<template>
  <div class="banner">
    <div class="content-center">
      <div class="banner-body">
        <div class="banner-title">让资源高效流动，让服务触手可及</div>
        <div class="banner-subtitle">易隆创·服务生态——全国服务商火热招募中，共享服务生态价值！</div>
        <ConnectUsPopover>
          <div class="primary-btn">申请入驻</div>
        </ConnectUsPopover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  height: 460px;
  background-image: url('@/assets/img/service-provider/Banner/background.png');
  background-size: cover;
  background-position: center;

  .content-center {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .banner-body {
      .banner-title {
        font-family: @font-bold;
        font-size: 32px;
        line-height: 65px;
        letter-spacing: 2px;
      }
      .banner-subtitle {
        margin: 13px 0 53px;
        color: @info-color;
      }
      .primary-btn {
        width: 164px;
      }
    }
  }
}
</style>
